import React from "react";
import { CustomEditText } from "./InputText.elements";

export default function InputText({
  isPassword,
  onChange,
  error,
  autofocus,
}: any) {
  const inputType = isPassword ? "password" : "text";
  const isError: boolean = error != null && error.length > 0;

  return (
    <CustomEditText
      autoFocus={autofocus}
      error={isError}
      type={inputType}
      onChange={onChange}
    />
  );
}
